import './QuantityFilters.scss';

import { useEffect } from "react";
import { useState } from "react";

import { Box } from "@mui/material";

import { TextButton } from "../../common-components/Buttons/Buttons";

import EmergencyFilter from "../EmergencyFilter/EmergencyFilter";
import TypeFilter from "../TypeFilter/TypeFilter";
import IntervalFilter from "../IntervalFilter/IntervalFilter";
import RangeFilter from "../RangeFilter/RangeFilter";
import YearFilter from "../YearFilter/YearFilter";
import MonthFilter from "../MonthFilter/MonthFilter";

const QuantityFilters = ({onRangeChange, onYearChange, onWeekChange, onTypeChange, onMonthChange, onEmergencyChange, onReset, reset}) => {
    const [selectedInterval, setSelectedInterval] = useState('');

    useEffect(() => {
        setSelectedInterval('')
    }, [reset])

    const handleIntervalChange = (optionId) => {
        setSelectedInterval(optionId);

        if (optionId === 'week') {
            onWeekChange();
        } else if (optionId === 'range') {
            onRangeChange();
        } else if (optionId === 'year') {
            onYearChange();
        }
    };

    return (
        <Box className={"quantity_filters"}>
            <Box className={"quantity_filters_container"}>
                <Box className={"quantity_filters_container_filter"}>
                    <EmergencyFilter onEmergencyChange={onEmergencyChange} reset={reset}/>
                </Box>
                <Box className={"quantity_filters_container_filter"}>
                    <TypeFilter onTypeChange={onTypeChange} reset={reset}/>
                </Box>
                <Box className={"quantity_filters_container_filter"}>
                    <IntervalFilter onIntervalChange={handleIntervalChange} reset={reset}/>
                </Box>
                {selectedInterval === 'range' && (
                    <Box className={"quantity_filters_container_filter"}>
                        <RangeFilter onRangeChange={onRangeChange}/>
                    </Box>
                )}
                {selectedInterval === 'year' && (
                    <Box className={"quantity_filters_container_filter"}>
                        <YearFilter onYearChange={onYearChange}/>
                    </Box>
                )}
                {selectedInterval === 'month' && (
                    <Box className={"quantity_filters_container_filter"}>
                        <MonthFilter onMonthChange={onMonthChange}/>
                    </Box>
                )}
                <Box className={"quantity_filters_container_filter"}>
                    <TextButton title={"Сбросить"} onClick={onReset} active={true}/>
                </Box>
            </Box>
        </Box>
    )
}

export default QuantityFilters;
